import { render, staticRenderFns } from "./DependantsYN.vue?vue&type=template&id=00cd713e"
import script from "./DependantsYN.vue?vue&type=script&lang=js"
export * from "./DependantsYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports